import { Component } from '@theme/component';

/**
 * Announcement Bar Slider
 * Deslizamiento horizontal automático.
 */
export class AnnouncementBar extends Component {
  #current = 0;
  #interval;

  connectedCallback() {
    super.connectedCallback();

    this.refs.slides?.forEach((slide, index) => {
      slide.style.transition = "transform .6s ease, opacity .6s ease";
      slide.style.position = "absolute";
      slide.style.top = "0";
      slide.style.left = "0";
      slide.style.width = "100%";

      if (index === 0) {
        slide.style.transform = "translateX(0)";
        slide.style.opacity = "1";
        slide.setAttribute("aria-hidden", "false");
      } else {
        slide.style.transform = "translateX(100%)";
        slide.style.opacity = "0";
        slide.setAttribute("aria-hidden", "true");
      }
    });

    this.style.position = "relative";
    this.style.overflow = "hidden";

    this.addEventListener("mouseenter", () => this.pause());
    this.addEventListener("mouseleave", () => this.resume());

    document.addEventListener(
      "visibilitychange",
      this.#handleVisibilityChange
    );

    this.play();
  }

  next() {
    this.goTo(this.#current + 1);
  }

  previous() {
    this.goTo(this.#current - 1);
  }

  goTo(index) {
    const slides = this.refs.slides || [];
    const total = slides.length;

    if (total <= 1) return;

    let next = index;

    if (next >= total) next = 0;
    if (next < 0) next = total - 1;

    const currentSlide = slides[this.#current];
    const nextSlide = slides[next];

    if (!currentSlide || !nextSlide) return;

    // Posicionar el siguiente fuera de la pantalla
    nextSlide.style.transition = "none";
    nextSlide.style.transform = "translateX(100%)";
    nextSlide.style.opacity = "1";
    nextSlide.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => {
      nextSlide.style.transition =
        "transform .6s ease, opacity .6s ease";
      currentSlide.style.transition =
        "transform .6s ease, opacity .6s ease";

      currentSlide.style.transform = "translateX(-100%)";
      currentSlide.style.opacity = "0";

      nextSlide.style.transform = "translateX(0)";
      nextSlide.style.opacity = "1";
    });

    setTimeout(() => {
      currentSlide.setAttribute("aria-hidden", "true");
      currentSlide.style.transform = "translateX(100%)";
    }, 650);

    this.#current = next;
  }

  play(interval = this.autoplayInterval) {
    if (!this.autoplay) return;

    clearInterval(this.#interval);

    this.#interval = setInterval(() => {
      if (this.matches(":hover") || document.hidden) return;
      this.next();
    }, interval);
  }

  pause() {
    clearInterval(this.#interval);
  }

  resume() {
    this.play();
  }

  get autoplay() {
    return Boolean(this.autoplayInterval);
  }

  get autoplayInterval() {
    const interval = parseInt(this.getAttribute("autoplay"), 10);

    if (Number.isNaN(interval)) return null;

    return interval * 1000;
  }

  #handleVisibilityChange = () => {
    if (document.hidden) {
      this.pause();
    } else {
      this.resume();
    }
  };
}

if (!customElements.get("announcement-bar-component")) {
  customElements.define("announcement-bar-component", AnnouncementBar);
}
